import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DataProvider"] */ "/app/src/components/data-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DebugLogger","FaviconUpdater"] */ "/app/src/components/features/GlobalLazyLoaders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleSync"] */ "/app/src/i18n/locale-sync.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/app/src/i18n/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileGuard"] */ "/app/src/providers/MobileGuard.tsx");
